(function (global) {
  function encodeState(state) {
    return btoa(JSON.stringify(state));
  }

  function decodeState(encoded) {
    try {
      return JSON.parse(atob(encoded));
    } catch (error) {
      return null;
    }
  }

  function getStateFromSearch(search, key) {
    return getStateFromSearchWithContract(search, key);
  }

  function getStateFromSearchWithContract(search, key, contractId) {
    const params = new URLSearchParams(search || '');
    if (!params.has(key)) return null;

    const decoded = decodeState(params.get(key));
    if (!decoded) return null;

    // Contracted payload.
    if (decoded && decoded.c && decoded.d !== undefined) {
      if (!global.UrlStateContracts) {
        return decoded.d;
      }

      if (contractId) {
        return global.UrlStateContracts.decode(contractId, decoded);
      }
      return decoded.d;
    }

    if (contractId && global.UrlStateContracts) {
      return global.UrlStateContracts.decode(contractId, decoded);
    }

    return decoded;
  }

  function createShareableUrl(state, key) {
    return createShareableUrlWithContract(state, key);
  }

  function createShareableUrlWithContract(state, key, contractId) {
    let payload = state;
    if (contractId && global.UrlStateContracts) {
      payload = global.UrlStateContracts.encode(contractId, state);
    }

    const encoded = encodeState(payload);
    return window.location.origin + window.location.pathname + '?' + key + '=' + encoded;
  }

  global.UrlState = {
    encodeState,
    decodeState,
    getStateFromSearch,
    getStateFromSearchWithContract,
    createShareableUrl,
    createShareableUrlWithContract
  };
})(window);
